import { render, staticRenderFns } from "./WillIntroduction.vue?vue&type=template&id=806431b6&"
import script from "./WillIntroduction.vue?vue&type=script&lang=js&"
export * from "./WillIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports